<template>
  <div class="donation-form">
    <fieldset>
      <div class="row">
        <div class="column column-100">
          <CountrySwitcher/>
        </div>
      </div>
      <div class="row">
        <div class="column column-100">
          <CurrencySwitcher/>
        </div>
      </div>
      <SumSelector/>
      <div class="row">
        <div class="column column-100">
          <ModeSwitcher/>
        </div>
      </div>
      <div v-if="!isLinkMethod()">
        <div v-if="step === 'checkout' && checkoutType === 'widget'">
          <div class="row">
            <div class="column column-100">
              <StripeElementPayment ref="paymentWidget" :pk="checkoutParams.publicKey" :elements-options="{ clientSecret: checkoutParams.clientSecret, appearance }" :confirm-params="{ return_url: returnUrl }" @error="showErrorPage" />
            </div>
          </div>
          <div class="row">
            <div class="column">
              <button class="button button-outline donate" @click="requestTransaction">{{ action }}</button>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="row">
            <div class="column column-100">
              <Email/>
            </div>
          </div>
          <div class="row">
            <div class="column column-100">
              <input type="text" name="firstname" @input="updateValue" :placeholder="labels['name']" :value="firstname">
            </div>
          </div>
          <div class="row">
            <div class="column">
              <Agreement/>
            </div>
          </div>
          <div class="row">
            <div class="column">
              <button class="button button-outline donate" @click="donate">{{ action }}</button>
            </div>
          </div>
          <div class="external-footer">
            <div class="row">
              <div v-if="mode === 'one-off'" class="column column-100">
                ApplePay и GooglePay <a href="https://donate.stripe.com/14kbJn22EgM47i8004" target="_blank">работают по ссылке</a>. А еще нас можно <a href="/crypto">поддержать в криптовалюте</a>.
              </div>
              <div v-else class="column column-100">
                Или поддержите нас <a href="/crypto">в криптовалюте</a>.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row">
          <div class="column method-description">
            {{ labels[activeMethod + '-description'] }}
          </div>
        </div>
        <div class="row">
          <div class="column">
            <a class="button button-outline donate" :href="methods[activeMethod].url" target="_blank">{{ labels[activeMethod + '-label'] }}</a>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { StripeElementPayment } from '@vue-stripe/vue-stripe'
import SumSelector from './SumSelector.vue'
import CountrySwitcher from './CountrySwitcher.vue'
import CurrencySwitcher from './CurrencySwitcher.vue'
import ModeSwitcher from './ModeSwitcher.vue'
import Email from './Email.vue'
import Agreement from './Agreement.vue'
import { LABELS, VALIDATION_MESSAGES } from '@/settings'

export default {
  components: { Agreement, CountrySwitcher, CurrencySwitcher, Email, ModeSwitcher, SumSelector, StripeElementPayment },
  computed: mapState({
    firstname: state => state.donation.firstname,
    email: state => state.donation.email,
    month: state => state.donation.month,
    mode: state => state.donation.mode,
    terms: state => state.terms,
    lang: state => state.language,
    labels: state => LABELS[state.language],
    action: state => LABELS[state.language][state.donation.month ? 'subscribe' : 'donate'],
    activeMethod: state => state.donation.method,
    methods: state => state.operators,
    step: state => state.step,
    checkoutType: state => state.checkoutType,
    checkoutParams: state => state.checkoutParams,
    returnUrl: state => `${document.location.origin}/complete?donationId=${state.internalDonationId}`,
    sum: state => state.donation.sum
  }),
  data () {
    return {
      appearance: {
        theme: 'minimal',

        variables: {
          colorPrimary: '#FF6F37',
          colorBackground: '#EFF2F3',
          colorText: '#000',
          colorDanger: '#FF6F37',
          fontFamily: 'Ideal Sans, system-ui, sans-serif',
          spacingUnit: '4px',
          borderRadius: '0px'
        }
      },
      confirmParams: {
        return_url: ''
      }
    }
  },
  methods: {
    isLinkMethod () {
      return !!this.methods[this.activeMethod].url
    },
    updateValue (e) {
      const prop = e.target.name
      const value = e.target.value
      const change = { prop, value }
      this.$store.commit('updateDonation', change)
    },
    donate () {
      if (!this.sum) {
        return
      }
      // TODO missing validation scope, returns true even when has errors
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('donate')
        }
      })
    },
    requestTransaction () {
      this.$refs.paymentWidget.submit()
    },
    resetForm () {
      this.$store.dispatch('resetForm')
    },
    showSuccessPage () {
      this.$store.dispatch('showStep', 'thanks')
    },
    showErrorPage () {
      this.$store.dispatch('showStep', 'error')
    }
  },
  mounted () {
    const lang = this.lang
    this.$validator.localize(lang, VALIDATION_MESSAGES[lang])
  }
}
</script>

<style scoped>
  .oi-donation-form fieldset,
  .oi-donation-form input,
  .oi-donation-form select,
  .oi-donation-form textarea {
    margin-bottom: 10px;
  }
  .oi-donation-form .method-description {
    margin-bottom: 10px!important;
  }
  .oi-donation-form .external-footer,
  .oi-donation-form .external-footer p {
    font-size: 12px;
    padding-bottom: 10px;
  }

  .oi-donation-form .external-footer {
    padding-bottom: 10px;
  }
</style>
